import { h } from 'preact';

export default () => {
  return (
    <div class='mfa-registration step'>
      <h3>Step 3</h3>
      <p>
        Register an MFA device. After authenticating with Google this will
        provide a QR code. Scan it with your favorite MFA mobile client,
        like <a href='https://authy.com/download' target='_blank'>Authy</a>.
      </p>
      <a
        href={`https://${API_ROOT}/auth/signin?action=mfa`}
        class='button'
        target='_blank'
      >Register MFA device</a>
    </div>
  );
};



// WEBPACK FOOTER //
// ./components/mfa/index.js